const EVENT_ID = 'data-event';
const EVENT_SCOPE = 'data-event-scope';
const EVENT_ID_PREFIX = 'EVENTS.';
const OVERLAY_CALENDAR = 'mat-calendar';
const TITLE_HOLDERS = 'a.nav-link, .mat-tab-label';
const SCOPED_PARTS: { selector: string, part: string }[] = [
  { selector: '.ngb-dp-arrow-btn[aria-label="Previous month"]', part: 'CALENDAR.PREVIOUS-MONTH' },
  { selector: '.ngb-dp-arrow-btn[aria-label="Next month"]', part: 'CALENDAR.NEXT-MONTH' },
  { selector: 'select[aria-label="Select month"]', part: 'CALENDAR.MONTH' },
  { selector: 'select[aria-label="Select year"]', part: 'CALENDAR.YEAR' },
  { selector: '.ngb-dp-day', part: 'CALENDAR.DAY' },
  { selector: 'a.page-link[aria-label="Previous"]', part: 'PREVIOUS' },
  { selector: 'a.page-link[aria-label="Next"]', part: 'NEXT' },
  { selector: 'a.page-link[href]', part: 'PAGE' },
  { selector: '.cal-event, mwl-calendar-event-title', part: 'CALENDAR.VISIT' },
  { selector: 'mwl-calendar-month-cell, .cal-day-view mwl-calendar-week-view-hour-segment', part: 'CALENDAR.DAY' },
  { selector: '.mat-calendar-period-button', part: 'DATEPICKER.PERIOD' },
  { selector: '.mat-calendar-previous-button', part: 'DATEPICKER.PREVIOUS' },
  { selector: '.mat-calendar-next-button', part: 'DATEPICKER.NEXT' },
  { selector: 'mat-month-view .mat-calendar-body-cell', part: 'DATEPICKER.DAY' },
  { selector: 'mat-year-view .mat-calendar-body-cell', part: 'DATEPICKER.MONTH' },
  { selector: 'mat-multi-year-view .mat-calendar-body-cell', part: 'DATEPICKER.YEAR' }
];

export function eventIdOf(target: Element): string {
  for (let node = target; node; node = node.parentElement) {
    const id = node.getAttribute(EVENT_ID);
    if (id) {
      return id;
    }
    const scope = scopeOf(node);
    if (scope) {
      return scopedIdOf(target, node, scope);
    }
    const title = node.matches(TITLE_HOLDERS) ? onlyIdInside(node) : undefined;
    if (title) {
      return title;
    }
  }
  return undefined;
}

function scopeOf(node: Element): string {
  if (node.localName !== OVERLAY_CALENDAR) {
    return node.getAttribute(EVENT_SCOPE);
  }
  for (let i = 0; i < node.classList.length; i++) {
    if (node.classList[i].indexOf(EVENT_ID_PREFIX) === 0) {
      return node.classList[i];
    }
  }
  return undefined;
}

function scopedIdOf(target: Element, scopeHost: Element, scope: string): string {
  for (const { selector, part } of SCOPED_PARTS) {
    const match = target.closest(selector);
    if (match && scopeHost.contains(match)) {
      return scope + '.' + part;
    }
  }
  return undefined;
}

function onlyIdInside(node: Element): string {
  const marked = node.querySelectorAll('[' + EVENT_ID + ']');
  return marked.length === 1 ? marked[0].getAttribute(EVENT_ID) : undefined;
}
